import 'es6-promise/auto'
import axios from 'axios'
import { query } from 'vue-gtag';

let emitter = null;

const apiClient = axios.create({
    baseURL: `https://muzible.com/api/v1`, //3002    
    // ---------------
  })

const apiClientTracker = axios.create({
    baseURL: `https://tracker.muzible.com/api/v1`, //3003
    // ---------------
  })

const apiClientTickets = axios.create({
    baseURL: `https://tickets.muzible.com/api/v1`, //3005
    // ---------------
  })

const apiClientMuze = axios.create({
    baseURL: `https://muze.muzible.com/api/v1`, //3006
    // ---------------
  })

export default {
    setEmitter(em) {
      emitter = em;
    },
    postLogin(credentials){ // OK - enabled BACKEND
        return apiClient.post('/auth/login', credentials, {withCredentials: true})
      },
    auth2fa(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` },
          withCredentials: true
        };
        const data = { 
                                              code: credentials.code
        };  
      return apiClient.post('/auth/auth2fa', data, config )
      },
    postCredentials(credentials){ // OK - enabled BACKEND
        return apiClient.post('/auth/register', credentials, {withCredentials: true})
      },
    checkJWTValid(accdata){ // OK - enabled BACKEND
        const params = {
          email: accdata.email,
          token: accdata.token
        };
        return apiClient.get('/auth/jwt', { params } )
      },
    disableauth2fa(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` },
          withCredentials: true
        };
        const data = { 
                                              code: credentials.code
        };  
      return apiClient.post('/auth/disable2fa', data, config )
      },
    enableauth2fa(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` },
          withCredentials: true
        };
        const data = { 
                                              code: credentials.code, 
                                              pass: credentials.pass
        };  
        return apiClient.post('/auth/enable2fa', data, config )
      },
    get2faQR(credentials){ // OK - enabled BACKEND
          const config = {
            headers: { 'Authorization': `Bearer ${credentials.token}` },
            params: {
              email: 'removed'
            }
          };
      return apiClient.get('/auth/2faqr', config )
      },
    checkEmail(email){  // OK - enabled BACKEND
        return apiClient.get('/auth/checkemail', { params: email } )
      },
    checkUsername(username){ // OK - enabled BACKEND
        const params = {
          username: username.username,
          creator: username.creator
        };
        return apiClient.get('/auth/checkusername', { params } )
      },


    // COOKIES Endpointy
    setUserCookies(credentials){ // OK - enabled BACKEND
      const config = {
        headers: { 'Authorization': `Bearer ${credentials.token}` },
        withCredentials: true
      };
      const data = {
                    email: 'removed'
      };
      return apiClient.post('/auth/setUserCookies', data, config )    
    },
    deleteUserCookies(credentials){ // OK - enabled BACKEND 
        return apiClient.post('/auth/deleteUserCookies', credentials, {withCredentials: true} )    
    },

    // ADRESY Endpointy

    storeAddress(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              name: credentials.name, 
                                              surname: credentials.surname,
                                              address: credentials.address,
                                              address2: credentials.address2,
                                              postal: credentials.postal,
                                              city: credentials.city,
                                              country: credentials.country,
                                              tel: credentials.tel
        };  
        return apiClient.post('/auth/storeaddress', data, config )
    },
    removeAddress(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              email: 'removed'
        };  
        return apiClient.post('/auth/removeaddress', data, config )
    },
    storeCompany(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              company: credentials.company, 
                                              companyvat: credentials.companyvat,
                                              company_address: credentials.company_address,
                                              company_postal: credentials.company_postal,
                                              company_city: credentials.company_city,
                                              company_country: credentials.company_country
        };  
        return apiClient.post('/auth/storecompany', data, config )
    },
    removeCompany(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              email: 'removed'
        };  
        return apiClient.post('/auth/removecompany', data, config )
    },
    disableAccount(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              pass: credentials.pass
        };  
        return apiClient.post('/auth/disableaccount', data, config )
    },  
    enableAccount(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              email: 'removed'
        };  
        return apiClient.post('/auth/enableaccount', data, config )
    },
    changeUsername(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              pass: credentials.pass,
                                              uid: credentials.uid,
                                              newusername: credentials.newusername
        };  
        return apiClient.post('/auth/changeusername', data, config )
    },
    changeEmail(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                                              pass: credentials.pass,
                                              uid: credentials.uid,
                                              newemail: credentials.newemail
        };  
        return apiClient.post('/auth/changeemail', data, config )
    },


      // ROZNE Endpointy

      forgotPassToken(emaildata){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${emaildata.token}` },
          params: { 
                    email: 'removed'
                  }
        };
        return apiClient.get('/auth/forgotpasstoken', config )
      },
      resetPass(info){  // OK - enabled BACKEND
        return apiClient.post('/auth/resetpass', info )
      },
      forgotPass(emaildata){ // OK - enabled BACKEND
        const params = {
          email: emaildata.email
        };
        return apiClient.get('/auth/forgotpass', { params } )
      },
      unsubscribe(credentials){ // OK - enabled BACKEND
        const params = {
          uid: credentials.uid,
        };
        return apiClient.post('/auth/unsub', params )
      },
      setUserCreatorVerify(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                    email: 'removed'
        };        
        return apiClient.post('/auth/setUserCreatorVerify', data, config )
      },
      consent(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` }
        };
        const data = { 
                    email: 'removed'
        };   
        return apiClient.post('/auth/consent', data, config )
      },
      getCollectionsMusic(accdata){ // OK - enabled BACKEND
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              email: 'removed'
            }
          };
        return apiClient.get('/auth/collections', config )
      },
      getCollectionsNFT(accdata){ // OK - enabled BACKEND
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              email: 'removed'
            }
          };
        return apiClient.get('/auth/nftcollections', config )
      },
      getSubscriptions(accdata){ // OK - enabled BACKEND
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              email: 'removed'
            }
          };
        return apiClient.get('/auth/subscriptions', config )
      },

      // End ROZNE

      // Player
      getUserPlaylists(accdata){
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` }
          };
        return apiClientMuze.get('/player/userplaylists', config )
      },
      getUserExtPlaylists(accdata){
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` }
          };
        return apiClientMuze.get('/player/userextplaylists', config )
      },
      getUserFavSongs(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        return apiClientMuze.get('/player/userfavsongs', config )
      },
      getUserCurrentSongs(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        return apiClientMuze.get('/player/usercurrentsongs', config )
      },
      addUserFavSong(accdata){ 
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    song: accdata.song
        };
        return apiClientMuze.post('/player/addfavsong', data, config )
      },
      removeUserFavSong(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    song: accdata.song
        };
        return apiClientMuze.post('/player/removefavsong', data, config )
      },
      removeTrackFromPlaylist(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    playlistId: accdata.playlistId,
                    trackId: accdata.trackId
        };
        return apiClientMuze.post('/player/removeTrackFromPlaylist', data, config )
      },
      addTrackToPlaylist(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    playlistId: accdata.playlistId,
                    trackId: accdata.trackId
        };
        return apiClientMuze.post('/player/addTrackToPlaylist', data, config )
      },
      createNewPlaylist(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    playlist: accdata.playlist
        };
        return apiClientMuze.post('/player/createNewPlaylist', data, config )
      },
      deletePlaylist(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    playlistId: accdata.playlistId
        };
        return apiClientMuze.post('/player/deletePlaylist', data, config )
      },
      setUserCurrentSongs(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    songs: accdata.songs
        };
        return apiClientMuze.post('/player/setUserCurrentSongs', data, config )
      },
      getUserSubscribedCreators(accdata){
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` }
          };
        return apiClientMuze.get('/player/userSubscribedCreators', config )
      },
      getPlaylistTracks(accdata){
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              trackIds: accdata.trackIds 
            }
          };
        return apiClientMuze.get('/player/getPlaylistTracks', config )
      },
      getArtistTracks(accdata){ // Random 3 artist tracks
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              id: accdata.id 
            }
          };
        return apiClientMuze.get('/player/getArtistTracks', config )
      },
      getCreatorTracks(accdata){ // Random 3 creator tracks
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              id: accdata.id 
            }
          };
        return apiClientMuze.get('/player/getCreatorTracks', config )
      },
      getQuerySearch(accdata){
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              query: accdata.query,
              filter: accdata.filter 
            }
          };
        return apiClientMuze.get('/player/getQuerySearch', config )
      },
      getUserLocationForTrack(accdata){
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: {
              longitude: accdata.longitude,
              latitude: accdata.latitude,
              trackId: accdata.trackId 
            }
          };
        return apiClientMuze.get('/player/getUserLocationForTrack', config )
      },
      getTrackById(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` },
          params: {
            trackId: accdata.track_id
          }
        };
        return apiClientMuze.get('/player/getTrackById', config )
      },

      // End Player

      // Tracker
      logTrackerStart(accdata){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    trackid: accdata.trackid
        };
        return apiClientTracker.post('/tracker/logTrackerStart', data, config )
      },
      logTrackerEnd(accdata){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    trackid: accdata.trackid
        };
        return apiClientTracker.post('/tracker/logTrackerEnd', data, config )
      },
      logTrackerPause(accdata){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    trackid: accdata.trackid
        };
        return apiClientTracker.post('/tracker/logTrackerPause', data, config )
      },
      logErrorMedia(accdata){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    trackid: accdata.trackid,
                    err: accdata.err
        };
        return apiClientTracker.post('/tracker/logErrorMedia', data, config )
      },

      // TrackerEnd

      // Uploads Endpoints
      upload2faFile(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 
            'Content-Type': 'multipart/form-data', 
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${credentials.token}`
          },
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            emitter.emit('progressUploadF', percentCompleted)
          }
        };
        
        return apiClient.post('/auth/upload2fafile', credentials.formData, config)
      },
      upload2faFileRev(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 
            'Content-Type': 'multipart/form-data', 
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${credentials.token}`
          },
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            emitter.emit('progressUploadB', percentCompleted)
          }
        };
        
        return apiClient.post('/auth/upload2fafilerev', credentials.formData, config)
      },
      upload2faFileAddress(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 
            'Content-Type': 'multipart/form-data', 
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${credentials.token}`
          },
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            emitter.emit('progressUploadA', percentCompleted)
          }
        };
        
        return apiClient.post('/auth/upload2fafileaddress', credentials.formData, config)
      },
      upload2faFileCompany(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 
            'Content-Type': 'multipart/form-data', 
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${credentials.token}`
          },
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            emitter.emit('progressUploadC', percentCompleted)
          }
        };
        
        return apiClient.post('/auth/upload2fafilecompany', credentials.formData, config)
      },

      upload2faFileCreator(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 
            'Content-Type': 'multipart/form-data', 
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${credentials.token}`
          },
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            emitter.emit('progressUploadCreator', percentCompleted)
          }
        };
        
        return apiClient.post('/auth/upload2fafilecreator', credentials.formData, config)
      },
      // End Uploads

      // Tickets
      getTickets(accdata){
          const config = {
            headers: { 'Authorization': `Bearer ${accdata.token}` },
            params: { 
                      page: accdata.page || 1,
                      limit: accdata.limit || 10 
                    }
          };

        return apiClientTickets.get('/tickets/tickets', config )
      },
      getTicket(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` },
          params: { 
                    ticketid: accdata.ticket_id
                  }
        };
        return apiClientTickets.get('/tickets/getticket', config )
      },
      requestTicketRefundPolicy(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    ticketid: accdata.ticket_id
        };
        return apiClientTickets.post('/tickets/requestrefundpolicy', data, config )
      },
      requestTicketRefund(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    ticketid: accdata.ticket_id
        };
        return apiClientTickets.post('/tickets/requestrefund', data, config )
      },
      generateAppleWalletPass(accdata) // TODO ENABLE BACKEND
      {
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    ticketid: accdata.ticket_id
        };
        return apiClientTickets.post('/tickets/generateapplewalletpass', data, config )
      },
      generateGoogleWalletPass(accdata) // TODO ENABLE BACKEND
      {
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    ticketid: accdata.ticket_id
        };
        return apiClientTickets.post('/tickets/generategooglewalletpass', data, config )
      },
      shareTicketToVerse(accdata){ // TODO ENABLE BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    post_data: accdata.post_data,
                    verse_username: accdata.verse_username
        };
        return apiClientTickets.post('/tickets/sharetickettoverse', data, config )
      },
      transferTicket(accdata){
        const config = {
          headers: { 'Authorization': `Bearer ${accdata.token}` }
        };
        const data = { 
                    ticketid: accdata.ticket_id,
                    recipientUserId: accdata.recipientUserId,
                    pass: accdata.pass
        };
        return apiClientTickets.post('/tickets/transferticket', data, config )
      },
      // End Tickets

      // Crypto Endpoints
      getCryptoDashboardData(){ // OK - enabled BACKEND
        return apiClient.get('/auth/getcryptodashboarddata')
      },
      getCryptoUserData(credentials){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${credentials.token}` },
          params: { 
                   email: 'removed'
                  }
        };
        return apiClient.get('/auth/getcryptouserdata', config )
      },

  // Metamask
  checkandgetMetamaskWallet(info){ // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
        };
    const data = {
      pass: info.pass,
      address: info.address
    };
    return apiClient.post('/auth/addmetamaskaddress', data, config )
  },

  getUserMetamaskWallets(info){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${info.token}` },
          params: { 
                   uid: info.uid
                  }
        };
    return apiClient.get('/auth/getmetamaskwallets', config )
  },
  getTransactions(info){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${info.token}` },
          params: { 
                    from: info.from,
                    to: info.to,
                    uid: info.uid
                  }
        };
    return apiClient.get('/auth/gettransactions', config )
  },
  getNFTOffers(info){ // OK - enabled BACKEND
        const config = {
          headers: { 'Authorization': `Bearer ${info.token}` },
          params: { 
                    search: info.search,
                    type: info.type,
                    uid: info.uid                  
                  }
        };
    return apiClient.get('/auth/getnftoffers', config )
  },

  removeMetamaskWallet(info){ // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      uid: info.uid,
      address: info.address
    };
    return apiClient.post('/auth/removemetamaskwallet', data, config )
  },

  getLifeTokenAddress(){ // OK - enabled BACKEND
    return apiClient.get('/static/getlifetokenaddress')
  },

  getLifeMasterAddress(){ // OK - enabled BACKEND
    return apiClient.get('/static/getlifemasteraddress')
  },

  getLifeTokenABI(){ // OK - enabled BACKEND
    return apiClient.get('/static/getlifetokenabi')
  },

  getAccountHistoryWallets(info){ // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      uid: info.uid
    };
    return apiClient.post('/auth/getaccounthistorywallets', data, config )
  },

  sendTokensToUser(info){ // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      pass: info.pass,
      touser: info.touser,
      amount: info.amount
    };
    return apiClient.post('/auth/sendtokenstouser', data, config )
  },

  // Remember timestamp, and compute dividend after moveTostaking executed
  moveToStaking(info){ // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      amount: info.amount // how much to send
    };
    return apiClient.post('/auth/movetostaking', data, config )
  },

  // Remember Timestamp and compute dividend after moveFromStaking executed
  moveFromStaking(info){  // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      amount: info.amount // how much to withdraw
    };
    return apiClient.post('/auth/movefromstaking', data, config )
  },

      // End Crypto


      // Buy Endpoints

      createStripeIntentToken(credentials){  // OK - enabled BACKEND
        const params = {
          email: credentials.email,
          tokens: credentials.tokens,
          price: credentials.price,
          amount: credentials.amount
        };
        return apiClient.post('/buy/stripe_create_token', params )
      },
      createPaypalIntentToken(credentials){ // OK - enabled BACKEND
        const params = {
          email: credentials.email,
          tokens: credentials.tokens,
          price: credentials.price,
          amount: credentials.amount
        };
        return apiClient.post('/buy/create-payment-token', params )
      },
      executePaypalIntentToken(credentials){ // OK - enabled BACKEND
        const params = {
          email: credentials.email,
          tokens: credentials.tokens,
          orderID: credentials.orderID,
          amount: credentials.amount
        };
        return apiClient.post('/buy/execute-payment-token', params )
      },
  // Metamask Token transfer from metamask to platform
  // check trx for status, when success, update tokens
  // check also token address in trx! and amount
  // Log transaction IN Metamask address
  // If user complain check logs and trx
  executeMetamaskTokenTransferIntent(info){ // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = { 
        trx: info.trx,
        from: info.from,
        to: info.to
    };
    return apiClient.post('/buy/execute-transfer-metamask-token', data, config )
  },

  // Intent to buy tokens using metamask
  createMetamaskIntentTokenBuy(info){ // OK - enabled BACKEND
    const params = {
      email: info.email,
      tokens: info.tokens,
      price: info.price,
      amount: info.amount
    };
    return apiClient.post('/buy/create-payment-metamask-token-intent-buy', params )
  },

  // Metamask payment in eth for token
  // check trx for status, when success, update tokens for user and global tokens availability
  // LOG transaction BUY metamask amount
  // trx amount should match intentID amount
  // if all ok take num of tokens from intentID and update accordingly
  executeMetamaskPaymentTokenIntent(info){ // OK - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      trx: info.trx,
      from: info.from,
      to: info.to,
      intentID: info.intentID
    };
    return apiClient.post('/buy/execute-payment-metamask-token', data, config )
  },


  // First pay for intent, than send that request for validation
  sendTokensToWallet(info){ // OK - enabled BACKEND
    // Send tokens and pay transfer fee (in tokens!)
    // store and display valid intents
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      pass: info.pass,
      address: info.address, // address to send (has to be in connected addresses)
      amount: info.amount, // how much to send
    };
    return apiClient.post('/buy/transfer-out-tokens-intent', data, config)
  },

  // get all transfer intents and display those, onlyu valid for specific user (admin/validator)
  // each time check intents and user balance
  // get intents with status order/executed/rejected
  // Refresh that after each action taken
  getValidTransferIntents(info){ // TODO ENABLE - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` },
      };
    const params = {
      email: 'removed',
    };
    return apiClient.post('/buy/getvalidtransferintents', params, config )
  },

   // Only admin/validator can set transfer status
  // When paymewnt executed, change number of tokens for that user, update also in_transfer number
  setTransferIntentStatus(info){ // TODO ENABLE - enabled BACKEND
    const config = {
          headers: { 'Authorization': `Bearer ${info.token}` }
      };
    const data = {
      pass: info.pass,
      intentid: info.intentid,
      status: info.status,
      fee: info.fee,
    };
    return apiClient.post('/buy/settransferintentstatus', data, config )
  },  

  // End Buy Endpoints

}
